
export enum ClaimRelatedShipmentTypeCd {
	MANUALLY_RELATED = 'ManuallyRelated',
	OPERATIONALLY_RELATED = 'OperationallyRelated'}

